import CreateBookingRoleRequest from '@/models/BookingRoles/CreateBookingRoleRequest';

export default class CreateBookingRequest {
    dates: Date[] = [];
    branchId: string;
    companyId: string;
    locationId: string;
    departmentId: string;
    ownerId: string;
    isTest = false;
    testEmailAddresses = '';
    purchaseOrderNumber = '';
    instructions = '';
    roles: CreateBookingRoleRequest[] = [];
}